import LayoutField from 'component/element/workdoc/layout/form-layout'
import SelectWithIcon from 'component/element/workdoc/SelectWithIcon' 
import SelectCarBrand from 'component/element/workdoc/SelectCarBrand'
import SelectCarModel from 'component/element/workdoc/SelectCarModel'
import SelectCarSeries from 'component/element/workdoc/SelectCarSeries'
import SelectColor from 'component/element/workdoc/SelectColor'
import SelectCustomer from 'component/element/workdoc/SelectCustomer'
import SelectDateTime from 'component/element/workdoc/SelectDateTime'
// import RadioCustomerType from 'component/element/workdoc/RadioCustomerType'
// import RadioCustomerPaymentType from 'component/element/workdoc/RadioCustomerPaymentType'
// import RadioCustomerInstallment from 'component/element/workdoc/RadioCustomerInstallment'
// import RadioDeliveringAs from 'component/element/workdoc/RadioDeliveringAs'
import AutoSuggestionTitle from 'component/element/workdoc/AutoSuggestionTitle'
// import SWTCreditInstallment from 'view/workdoc/SWTCreditInstallment'
import SelectInsurerName from 'component/element/workdoc/SelectInsurerName'
import SelectPolicyType from 'component/element/workdoc/SelectPolicyType'
import SelectInsurerBranch from 'component/element/workdoc/SelectInsurerBranch'
import CheckWidget from 'component/element/workdoc/CheckWidget'
import 'App.css'
export const DEFAULT_SCHEMA = {
    vehicle: {
        title: "",
        type: "object",
        required: ["vehicle_registration_no","vehicle_type"],
        properties: {
            vehicle_id: {type: "string", title: "vehicle_id"},
            vehicle_registration_no: {type: "string", title: "ทะเบียนรถ", default: ""},
            vehicle_no: {type: "string", title: "เบอร์รถ", default: ""},
            province: {
                type: 'string',
                title: 'จังหวัด',
                default: "กรุงเทพมหานคร",
                options: {
                    option_field: 'province_options',
                },
            },
            has_tail: {type: "boolean", title: "มีทะเบียนหาง?", default: false},
            has_head: {type: "boolean", title: "มีทะเบียนหัว?", default: false},
            tail_vehicle_registration_no: {type: "string", title: "ทะเบียนหาง", default: ""},
            tail_province: {
                type: 'string',
                title: 'จังหวัด',
                options: {
                    option_field: 'province_options',
                },
            },
            head_vehicle_registration_no: {type: "string", title: "ทะเบียนหัว", default: ""},
            head_province: {
                type: 'string',
                title: 'จังหวัด',
                options: {
                    option_field: 'province_options',
                },
            },
            vehicle_type: {
                type: 'string',
                title: 'ประเภทรถ',
                default: 'SEDAN',
                options: {
                    icon_base_url: 'https://demo2.bigfix.co/korat/img/',
                    icon_size: '32x32',
                    icon_ext: 'png',
                    option_field: 'vehicle_type_options',
                }
            },
            brand_id: {type: "string", title: "ยี่ห้อ"},
            model_id: {type: "string", title: "รุ่น"},
            series_id: {type: 'string', title: 'โฉมปี (แบบ)'},
            brand: {type: "string", title: "ยี่ห้อ"},
            model: {type: "string", title: "รุ่น"},
            series: {type: 'string', title: 'โฉมปี (แบบ)'},
            color_vehicle: {type: "string", title: "สีรถ", default: ""},
            mileage: {type: "string", title: "หมายเลข กม.", default: ""},
            chassis_no: {type: "string", title: "หมายเลขตัวถัง", default: ""},
            engine_no: {type: "string", title: "หมายเลขเครื่อง", default: ""},
            number_of_wheels: {type: "string", title: "จำนวนล้อ", default: ""}
        }
    },
    driver: {
        title: "",
        type: "object",
        required: ['name','tel'],
        properties: {
            title: {type: 'string', title: 'คำนำหน้าชื่อ', default: ''},
            driver_id: {type: 'string', title: 'ชื่อคนขับ', default: ''},
            name: {type: 'string', title: 'ชื่อคนขับ', default: ''},
            // pay_type: {type: 'string', title: 'ประเภท', default: 'cash'},
            // installation: {type: 'boolean', title: 'ผ่อนชำระ', default: false},
            // installation_component: {type: 'object', title: 'รายการผ่อนชำระเงินสด'},
            // payment_method: {type: 'string', title: 'วิธีชำระเงิน', default: ''},
            // payment_method_remark: {type: 'string', title: '', default: ''},
            tel: {type: 'string', title: 'หมายเลขโทรศัพท์', default: ''},
            other_tel: {type: 'string', title: 'เบอร์ติดต่ออื่น', default: ''},
        }    
    },
    insurer: {
        title: "",
        type: "object",
        required: ["insurer_name"],
        properties: {
            insurer_name:{type: "string", title: "insurer_name", default: ""},
            insurer_id: {
                type: 'string',
                title: 'เลือกประกัน',
                default: '',
                options: {
                    option_field: 'insurer_options',
                },
            },
            policy_no: {type: "string", title: "หมายเลขกรมธรรม์", default: ""},
            // claim_no: {type: "string", title: "เลขที่เคลม", default: ""},
            // accident_no: {type: 'string', title: 'เลขที่แจ้งอุบัติเหตุ', default: ""},
            // claim_by: {type: "string", title: "พนักงานเคลม", default: ""},
            branch: {
                type: 'string',
                title: 'สาขา',
                default: '',
                options: {
                    option_field: 'province_options',
                },
            },
            policy_type: {
                type: 'string',
                title: 'ประเภทกรมธรรม์',
                default: '',
                options: {
                    option_field: 'policy_type_options',
                },
            },
            protection_money: {type: "string", title: "จำนวนเงินคุ้มครอง", default: ""},
            accident_receiving_date: {type: "string", title: "วันที่เริ่มคุ้มครอง", default: ""},
            accident_date: {type: "string", title: "วันที่หมดสัญญา", default: ""}
        }
    },
}

export const DEFAULT_UI_SCHEMA = {
    vehicle: {
        'ui:field': LayoutField,
        'ui:layout': [
            [
                {name: 'vehicle_registration_no', props: {md: 4}},
                {name: 'vehicle_no', props: {md: 2}},
                {name: 'province', props: {md: 6}}
            ],
            [
                {name: 'vehicle_type', props: {md: 6}},
                {name: 'has_tail', props: {md: 6}},
                {name: 'has_head', props: {md: 6}},
            ],
            [
                {name: 'tail_vehicle_registration_no', props: {md: 6}},
                {name: 'tail_province', props: {md: 6}}
            ],
            [
                {name: 'head_vehicle_registration_no', props: {md: 6}},
                {name: 'head_province', props: {md: 6}}
            ],
            [                
                {name: 'brand_id', props: {md: 6}}
            ],
            [
                {name: 'model_id', props: {md: 6}},
                {name: 'series_id', props: {md: 6}}
            ],
            [
                {name: 'color_vehicle', props: {md: 6}},
                {name: 'mileage', props: {md: 6}}
            ],
            [
                {name: 'chassis_no', props: {md: 6}},
                {name: 'engine_no', props: {md: 6}}
            ],
            [
                {name: 'number_of_wheels', props: {md: 6}}
            ]   
        ],
        province: {'ui:field': SelectWithIcon},
        tail_province: {'ui:field': SelectWithIcon},
        vehicle_type: {'ui:field': SelectWithIcon},
        brand_id: {'ui:field': SelectCarBrand},
        model_id: {'ui:field': SelectCarModel, 'type': 'vehicle'},
        series_id: {'ui:field': SelectCarSeries, 'type': 'vehicle'},
        vehicle_id: {'ui:widget': "hidden"},
        brand: {'ui:widget': "hidden"},
        model: {'ui:widget': "hidden"},
        series: {'ui:widget': "hidden"},
        head_vehicle_registration_no: {'ui:widget': "hidden",classNames:"hidden"},
        head_province: {'ui:widget': "hidden",classNames:"hidden"},
        color_vehicle: {'ui:field': SelectColor},
        has_tail:{'ui:field':CheckWidget},
        has_head:{'ui:field':CheckWidget,classNames:'hidden'}
    },
    driver: {
        'ui:field': LayoutField,
        'ui:layout': [
            [
                {name: 'title', props: {md: 2}},
                {name: 'name', props: {md: 4}},
                {name: 'tel', props: {md: 6}}
            ],
            [
                // {name: 'pay_type', props: {md: 6}},
                {name: 'other_tel', props: {md: 6}}
            ],
            // [
            //     {name: 'installation', doShow:true, props: {md: 6}}
            // ],
            // [
            //     {name: 'payment_method', props: {md: 6}}
            // ],
            // [
            //     {name: 'payment_method_remark', doShow:true, props: {md: 6}}
            // ],
            // [
            //     {name: 'installation_component', doShow:true, title: false, props: {md: 12}}
            // ]
        ],
        title: {'ui:field': AutoSuggestionTitle},
        name: {'ui:field': SelectCustomer, 'ui:input': true, 'type': 'driver'},
        driver_id: {'ui:widget': "hidden"},
        // pay_type: {'ui:field': RadioCustomerType},
        // installation: {'ui:field': RadioCustomerInstallment},
        // payment_method: {'ui:field': RadioCustomerPaymentType},
        // installation_component: {'ui:field': SWTCreditInstallment, 'ui:title': false}
    },
    insurer: {
        'ui:field': LayoutField,
        'ui:layout': [
            [
                {name: 'insurer_id', props: {md: 6}},
                {name: 'branch', props: {md: 6}}
            ],            
            [
                {name: 'policy_no', props: {md: 6}},
                {name: 'policy_type', props: {md: 6}}
            ],
            [
                // {name: 'claim_no', props: {md: 6}},
                {name: 'protection_money', props: {md: 6}},
                {name: 'accident_receiving_date', props: {md: 3}},
                {name: 'accident_date', props: {md: 3}}
            ],
            [
                // {name: 'accident_no', props: {md: 6}},
                // {name: 'accident_receiving_date', props: {md: 3}},
                // {name: 'accident_date', props: {md: 3}}
            ],
            [
                // {name: 'claim_by', props: {md: 6}}
            ]
        ],
        insurer_id: {'ui:field': SelectInsurerName},
        insurer_name: {'ui:widget': "hidden"},
        branch: {'ui:field': SelectInsurerBranch},
        policy_type: {'ui:field': SelectPolicyType},
        accident_receiving_date: {'ui:field': SelectDateTime, 'ui:time':false},
        accident_date: {'ui:field': SelectDateTime, 'ui:time':false},
        // claim_by: {'ui:field': SelectCustomer, 'ui:input': true},
    }
}


// WEBPACK FOOTER //
// ./src/view/tyre/report-asset-vehicle-page/AssetVehicleDocGenFormSchema.js